import React, { useEffect, useState } from "react";
import { SERVICE_MODALS_ERROR_STATES } from "../../ServiceFunctionsModal.types";
import { GeneralErrorsModal as Modal } from "./GeneralErrorsModal";
import { ErrorState, useErrorStore } from "./GlobalState";

export function GeneralErrorsModal() {
    const [open, setOpen] = useState(false);
    const [errorModalState, setErrorModalState] =
        useState<SERVICE_MODALS_ERROR_STATES>(
            SERVICE_MODALS_ERROR_STATES.DEFAULT,
        );

    const { errorState, setErrorState } = useErrorStore();

    useEffect(() => {
        switch (errorState) {
            case ErrorState.POST_SUSPENDED:
            case ErrorState.COMMENT_SUSPENDED:
                setErrorModalState(
                    SERVICE_MODALS_ERROR_STATES.RESOURCE_SUSPENDED,
                );
                setOpen(true);
                break;

            case ErrorState.POST_NOT_FOUND:
                setErrorModalState(
                    SERVICE_MODALS_ERROR_STATES.RESOURCE_NOT_FOUND,
                );
                setOpen(true);
                break;

            case ErrorState.USER_INACTIVE_OR_SUSPENDED:
                setErrorModalState(
                    SERVICE_MODALS_ERROR_STATES.USER_INACTIVE_OR_SUSPENDED,
                );
                setOpen(true);
                break;

            case ErrorState.GENERAL_ERROR:
                setErrorModalState(SERVICE_MODALS_ERROR_STATES.GENERAL_ERROR);
                setOpen(true);
                break;

            case ErrorState.STATE_INITIAL:
                setErrorModalState(SERVICE_MODALS_ERROR_STATES.DEFAULT);
                break;

            case ErrorState.LIMIT_EXCEEDED_ERROR:
                setErrorModalState(
                    SERVICE_MODALS_ERROR_STATES.LIMIT_EXCEEDED_ERROR,
                );
                setOpen(true);
                break;

            case ErrorState.NO_INTERNET:
                setErrorModalState(SERVICE_MODALS_ERROR_STATES.NO_INTERNET);
                setOpen(true);
                break;
        }
    }, [errorState]);

    const onClose = () => {
        setOpen(false);
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            setCurrentErrorState={setErrorState}
            modalCurrentAction={errorModalState}
        />
    );
}
